export enum LicenseTypeActionTypes {
    API_RESPONSE_SUCCESS = '@@licenseTypes/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@licenseTypes/API_RESPONSE_ERROR',

    GET_LICENSE_TYPES = '@@licenseTypes/GET_LICENSE_TYPES',
}
